'use client';

import { useIntl } from 'react-intl';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useCarousel } from './useCarousel';

export const CarouselNav = () => {
  const { atStart, atEnd, trackRef } = useCarousel();
  const { formatMessage } = useIntl();

  const scrollBySlides = (dir: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const firstChild = el.querySelector<HTMLElement>(':scope > *');
    if (!firstChild) return;
    const slideWidth =
      firstChild.getBoundingClientRect().width + parseFloat(getComputedStyle(el).columnGap || '0');
    // in the "CarouselList" component there are different configurations for visible items made with CSS variables
    // let's get the current one
    const itemsVisible = getComputedStyle(el).getPropertyValue('--items-visible');
    // now use the visible item count to calculate the scroll amount
    const count = parseInt(itemsVisible, 10);
    el.scrollBy({ left: dir * slideWidth * count, behavior: 'smooth' });
  };

  return (
    <>
      {!atStart && (
        <Button
          variant="icon-only"
          size="medium"
          aria-label={formatMessage({
            id: 'recoCarousel.aria.prevButton',
            defaultMessage: 'Vorheriges Element',
          })}
          className="bg-color-carousel-dot absolute top-1/2 left-1 z-30 size-5 -translate-y-1/2 rounded-full border-none shadow-lg"
          onClick={() => scrollBySlides(-1)}
          tabIndex={-1}
        >
          <span className="icon-emp-arrow-medium-left size-4" role="img" />
        </Button>
      )}
      {!atEnd && (
        <Button
          variant="icon-only"
          size="medium"
          aria-label={formatMessage({
            id: 'recoCarousel.aria.nextButton',
            defaultMessage: 'Nächstes Element',
          })}
          className="bg-color-carousel-dot absolute top-1/2 right-1 z-30 size-5 -translate-y-1/2 rounded-full border-none shadow-lg"
          onClick={() => scrollBySlides(1)}
          tabIndex={-1}
        >
          <span className="icon-emp-arrow-medium-right size-4" role="img" />
        </Button>
      )}
    </>
  );
};
